export enum RatingProviderType {
  TRIP_ADVISOR = 'TripAdvisor',
  EXPEDIA = 'Expedia',
}
